import { teamData } from '@/models/team-member.model';
import { UsersService } from '@/services/api/users.service';
import { CommonModule, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ChipModule } from 'primeng/chip';
import { UserData } from 'src/app/models/user-data.model';
import { TooltipModule } from 'primeng/tooltip';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { UserAvatarComponent } from './user-avatar.component';

@Component({
    selector: 'app-user-tag',
    standalone: true,
    imports: [
      ChipModule, 
      CommonModule, 
      AvatarModule,
      TooltipModule,
      UserAvatarComponent

    ],
    template: `
  <p-chip *ngIf="userImage && showLabel" [label]="user?.DisplayName || ''" [image]="userImage"></p-chip>
  <p-chip *ngIf="!userImage && showLabel" class="!py-0 !pl-0 !pr-4">
    <span class="bg-primary text-primary-contrast rounded-full w-8 h-8 flex items-center justify-center">
    {{ getInitials() }}
    </span>
    <span class="ml-2">
    {{ user?.DisplayName || user?.displayName || '' }}
    </span>
</p-chip>
<app-user-avatar [user]="user" [showLabel]="showLabel"/>
  `,
  styles: [`
    .avatar-align {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    
    .text-avatar ::ng-deep .p-avatar-text {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      line-height: 1 !important;
    }
  `]
})
export class UserTagComponent {
  @Input() user: UserData | Partial<UserData> | teamData | undefined;
  @Input() showLabel:boolean = true

  constructor(private usersService: UsersService) {
  }

  get userImage() {
    if (this.user && this.user.UID) {
      const userList = this.usersService.userList();
      const user = userList?.find((u: UserData) => u.UID === this.user?.UID);
      if (user && user.profilePicture) {
        return 'data:image/jpeg;base64,' + user.profilePicture;
      }
    } 
    return null;
    
  }

  getInitials() {
    if(!this.user) return 'N/A';
    const firstName = this.user?.DisplayName?.split(' ')[0] || '';
    const lastName = this.user?.DisplayName?.split(' ')[1] || '';
    return (firstName[0] || '') + (lastName[0] || '');
  }
}